import React , { useEffect } from 'react'

//import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form'
//import { use } from '../../../../superback';


export default function SearchDropUnidad( {myData , show , setClaveProd , setUnidad}) {

  function change( e )
  {
    console.log( "Se selecciono elemento") ;

    var sku = document.getElementById('select').value ;


    var e1 = document.getElementById('select') ;


    var text = e1.options[e1.selectedIndex].text;

    var nombre = text.split( "=>")[1] ;


    setUnidad( nombre ) ;

    console.log( sku ) ;

    setClaveProd( sku ) ;

    return ; // No hacemos nada


  }


    useEffect( () =>{

        var select = document.getElementById('select') ;


        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }

        for( var i = 0 ; i < myData.length ; i++)
        {
            

            var option = document.createElement("option");
            option.value = myData[i].c_claveUnidad ;
            option.text = myData[i].c_claveUnidad + "=>" + myData[i].nombre + "=> , " + myData[i].descripcion + " => " + myData[i].nota ;
            select.appendChild(option)


        }

    ;

    } , [myData])


  return (
    <div >
    <Form.Select id='select' onChange={change} aria-label="Default select example">
      <option>Open this select menu</option>
      <option value="1">One</option>
      <option value="2">Two</option>
      <option value="3">Three</option>
    </Form.Select>    </div>
  )
}
